import Nullstack from 'nullstack';
export default function IconTwentyFourHours({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-24-hours",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
  }), "   ", Nullstack.element("path", {
    d: "M4 13a8.094 8.094 0 0 0 3 5.24"
  }), "   ", Nullstack.element("path", {
    d: "M11 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2"
  }), "   ", Nullstack.element("path", {
    d: "M17 15v2a1 1 0 0 0 1 1h1"
  }), "   ", Nullstack.element("path", {
    d: "M20 15v6"
  }), " ");
}